import React from 'react'

export default function ContentField({ content }) {
  return <div className="form-input form-input--content">{content}</div>
}
